module.exports = __webpack_public_path__ + "img/PL08685.c5598a5f.png";